"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _GatewayService = _interopRequireDefault(require("../GatewayService.js"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var studentVariant = new _GatewayService["default"]('student-variant');

var fetchStudentVariants = function fetchStudentVariants() {
  var studentIds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var variantDisplaySchema = arguments.length > 1 ? arguments[1] : undefined;
  // we can't use the native axios query param object
  // becuase there are multiple 'studentId' entries.
  var params = new URLSearchParams();
  params.append('variantDisplaySchema', variantDisplaySchema);
  studentIds.forEach(function (studentId) {
    params.append('studentIds', studentId);
  });
  return studentVariant.get('studentvariant/list', {
    params: params
  });
};

var saveStudentVariants = function saveStudentVariants(students) {
  return studentVariant.post('studentvariant/list', students);
};

var _default = {
  fetchStudentVariants: fetchStudentVariants,
  saveStudentVariants: saveStudentVariants
};
exports["default"] = _default;